const GNO = ({ ...props }) => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_530_4757)">
      <path
        d="M58.7999 113.86C64.556 113.866 70.1502 111.956 74.6999 108.43L38.2299 72C35.2576 75.8456 33.4227 80.4474 32.9336 85.2831C32.4444 90.1189 33.3204 94.9949 35.4624 99.3579C37.6043 103.721 40.9263 107.396 45.0514 109.967C49.1765 112.537 53.9395 113.9 58.7999 113.9V113.86ZM167.21 87.85C167.21 82.1087 165.296 76.5312 161.77 72L125.3 108.43C129.146 111.406 133.75 113.243 138.588 113.734C143.426 114.224 148.305 113.348 152.67 111.204C157.035 109.061 160.712 105.736 163.282 101.608C165.852 97.4794 167.213 92.713 167.21 87.85Z"
        fill="black"
      />
      <path
        d="M185.54 48.19L169.41 64.32C175.3 71.3593 178.341 80.3486 177.934 89.5179C177.527 98.6873 173.702 107.372 167.212 113.862C160.722 120.352 152.037 124.177 142.868 124.584C133.699 124.991 124.709 121.95 117.67 116.06L100 133.73L82.33 116.06C75.2907 121.95 66.3014 124.991 57.132 124.584C47.9627 124.177 39.2779 120.352 32.7879 113.862C26.2978 107.372 22.4728 98.6873 22.066 89.5179C21.6592 80.3486 24.7001 71.3593 30.59 64.32L22.3 56L14.46 48.16C5.27608 63.3268 0.289843 80.6627 0.0122587 98.3912C-0.265325 116.12 4.17573 133.603 12.8803 149.05C21.5849 164.497 34.24 177.352 49.5487 186.297C64.8575 195.243 82.2693 199.957 100 199.957C117.731 199.957 135.143 195.243 150.451 186.297C165.76 177.352 178.415 164.497 187.12 149.05C195.824 133.603 200.265 116.12 199.988 98.3912C199.71 80.6627 194.724 63.3268 185.54 48.16V48.19Z"
        fill="black"
      />
      <path
        d="M172.35 31C163.012 21.2131 151.785 13.4225 139.349 8.09971C126.914 2.77687 113.527 0.0324097 99.9999 0.0324097C86.4728 0.0324097 73.0863 2.77687 60.6505 8.09971C48.2146 13.4225 36.988 21.2131 27.6499 31C25.1734 33.6043 22.8368 36.3382 20.6499 39.19L99.9999 118.53L179.37 39.17C177.176 36.3245 174.833 33.5973 172.35 31V31ZM99.9999 13.08C111.427 13.0228 122.75 15.2461 133.307 19.6195C143.863 23.993 153.441 30.4288 161.48 38.55L99.9999 100L38.5199 38.55C46.5584 30.4288 56.1365 23.993 66.6933 19.6195C77.25 15.2461 88.5732 13.0228 99.9999 13.08V13.08Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_530_4757">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GNO;
